module.exports = __webpack_public_path__ + "img/c3.f23d4da0.png";